import i18nConstructor from '@yandex-int/i18n';

import * as keyset from './KhStreamScreen.i18n';

export const i18n = i18nConstructor(keyset);
